import { isIos, isWx } from '../utils/api';

/** 活动列表
 * @param ctx
 * @param success
 * */
export const fetchActivityList = (ctx, success) => {
	comeinFetch({
		constant_key: 'json_activity_list',
		success: res => {
			success && success(res);
		},
		loading: true
	});
};

/** 校验活动是否有效
 * @param ctx
 * @param obj uuid: 活动唯一uuid
 * @param obj id: 活动内容id
 * */
export const fetchActivityCheck = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_activity_check',
		body: {
			activityUuid: obj.uuid,
			contentId: obj.id
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 活动详情
 * @param ctx
 * @param obj uuid 活动UUID
 * @param obj success
 * */
export const fetchActivityDetail = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_activity_detail',
		body: {
			activityUuid: obj.uuid
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/**
 * 匹配活动（课程、专栏是否参与活动）
 *
 * */
export const fetchCourseColumnInActivity = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_activity_get-activitycontent',
		body: {
			sid: obj.sid,
			type: obj.type,
			contentPrice: obj.price,
			inviterId: obj.inviterId,
			activityUuid: obj.activityUuid,
			contentId: obj.contentId
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			// 8006 当前商品没有参加活动
			if (code === '8006') return;

			ctx.dispatch('showTooltip', { msg: desc });
		},
		loading: false
	});
};

/** 添加活动参与记录(分享成功)
 * @param ctx
 * @param obj uuid 活动唯一UUID
 * @param obj id   活动内容id
 * */
export const fetchActivityAddJoin = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_activity_add-join',
		body: {
			activityUuid: obj.uuid,
			contentId: obj.id
		}
	});
};

/** 活动分享链接被点击
 * @param ctx
 * @param obj uuid        活动唯一UUID
 * @param obj id        活动内容id
 * @param obj inviterId    邀请人ID
 * */
export const fetchActivityClick = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_activity_click',
		body: {
			activityUuid: obj.uuid,
			contentId: obj.id,
			inviterId: obj.inviterId
		}
	});
};

/** 添加奖励记录
 * @param ctx
 * @param obj uuid 活动唯一UUID
 * @param obj id   活动内容id
 * @param obj inviteeId 被邀请人id
 * @param obj inviterId 邀请人id
 * @param obj orderNum 订单号
 * @param obj orderMoney 订单金额
 * @param obj orderMoney 订单金额
 * */
export const fetchActivityBuy = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_activity_buy',
		body: {
			activityUuid: obj.uuid,
			contentId: obj.id,
			inviteeId: obj.inviteeId,
			inviterId: obj.inviterId,
			orderNum: obj.orderNum,
			orderMoney: obj.orderMoney
		}
	});
};

/** 我的奖励列表
 * @param ctx
 * @param obj uuid 活动唯一ID
 * */
export const fetchActivityJoins = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_activity_joins',
		body: {
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '15',
			activityUuid: obj.uuid
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/** 奖励明细类别
 * @param ctx
 * @param obj
 * */
export const fetchActivityRewards = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_activity_rewards',
		body: {
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '15',
			contentId: obj.contentId
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/**
 * 获取参与活动商品基本信息
 * @param ctx
 * @param obj id:     商品id (课程/专栏)
 * @param obj type:   商品类型： 0：专栏 1：课程
 * @param obj uuid    活动唯一id：uuid
 * @param obj cid     活动内容(contentId) id
 * */
export const fetchActivityGoodsInfo = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_activity_get-activitygoods',
		body: {
			sid: obj.id,
			type: obj.type,
			activityUuid: obj.uuid,
			contentId: obj.cid
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			if (obj.error) {
				obj.error(code, desc);
			} else {
				ctx.dispatch('showTooltip', { msg: desc });
			}
		}
	});
};

export const fetchRoadshowForCollect = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_question_roadshowinfo-question',
		body: {
			roadshowid: obj.roadshowid
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			if (obj.error) {
				obj.error(code, desc);
			} else {
				ctx.dispatch('showTooltip', { msg: desc });
			}
		}
	});
};

export const fetchQuestionCollect = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_question_question-collection',
		body: {
			roadshowid: obj.roadshowid,
			content: obj.content
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			if (obj.error) {
				obj.error(code, desc);
			} else {
				ctx.dispatch('showTooltip', { msg: desc });
			}
		}
	});
};

export const fetchRoadshowShareCard = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_share-pic',
		body: {
			contentType: obj.contentType, // 类型，1：回放，14:路演，
			contentId: obj.contentId
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			if (obj.error) {
				obj.error(code, desc);
			} else {
				ctx.dispatch('showTooltip', { msg: desc });
			}
		}
	});
};

export const fetchRoadshowShareRank = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_share-rank',
		body: {},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			if (obj.error) {
				obj.error(code, desc);
			} else {
				ctx.dispatch('showTooltip', { msg: desc });
			}
		}
	});
};

export const fetchRoadshowShareVisit = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_share-visit',
		body: {
			vsign: obj.vsign
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			if (obj.error) {
				obj.error(code, desc);
			} else {
				ctx.dispatch('showTooltip', { msg: desc });
			}
		}
	});
};

/* 文章、路演收藏 */
/* 文章
 * 收藏文章
 * 取消收藏
 * */
/** 已收藏文章列表
 * @param ctx
 * @param obj pagestart: 起始页码
 * @param obj pagenum： 每页条数
 * */
export const fetchArticleCollects = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_article_collects',
		body: {
			pagestart: obj.pagestart || 0,
			pagenum: obj.pagenum || 0
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/* id：文章id */
export const fetchArticleCollect = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_article_collect',
		body: {
			articleid: obj.id
		},
		success: () => {
			ctx.dispatch('showTooltip', { msg: '关注成功', time: 1000 });
			obj.success && obj.success();
		},
		loading: true
	});
};
/* ids: 文章id集，数组 */
export const fetchArticleCollectCancel = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_article_collectcancel',
		body: {
			articleids: obj.ids
		},
		success: () => {
			ctx.dispatch('showTooltip', { msg: '取消关注', time: 1000 });
			obj.success && obj.success();
		},
		loading: true
	});
};

/* 路演
 * 已收藏路演列表
 * 收藏路演
 * 取消收藏
 * */
/**
 * @param ctx
 * @param obj pagestart: 起始页码
 * @param obj pagenum： 每页条数
 * */
export const fetchRoadshowCollectList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_collectlist',
		body: {
			pagestart: obj.pagestart || 0,
			pagenum: obj.pagenum || 0
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/* id：路演id */
export const fetchRoadshowCollect = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_collect',
		body: {
			roadshowid: obj.id
		},
		success: () => {
			ctx.dispatch('showTooltip', { msg: '关注成功', time: 1000 });
			obj.success && obj.success();
		},
		loading: true
	});
};
/* ids: 路演id集，数组 */
export const fetchRoadshowCollectCancel = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_deletecollect',
		body: {
			ids: obj.ids
		},
		success: () => {
			ctx.dispatch('showTooltip', { msg: '取消关注', time: 1000 });
			obj.success && obj.success();
		},
		loading: true
	});
};

/* 课程接口
 */
/**
 * 查询课程详情
 * @param ctx
 * @param obj id 必填，课程ID
 * */
export const fetchCourseDetail = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_class_detail',
		body: {
			cid: obj.id
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/**
 * 查询课程权限
 * @param ctx
 * @param obj id 必填，课程ID
 * */
export const fetchCourseAuth = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_class_authinfo',
		body: {
			cid: obj.id
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/**
 * 查询课程目录
 * @param ctx
 * @param obj id        必填      课程ID
 * @param obj type      必填      课程类型(type=0-查询试听以外的目录,type=1查询试听目录,type=2查询付费目录,type为空,则查询改课程下的全部目录)
 * @param obj pagenum   选填      页大小，默认 15
 * @param obj pagestart 选填      起始页，默认 0
 * */
export const fetchCourseChapterList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_class_chapterlist',
		body: {
			cid: obj.id,
			type: obj.type || '',
			pagenum: obj.pagenum || 15,
			pagestart: obj.pagestart || 0,
			from: obj.from || 1
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: code => {
			obj.error && obj.error(code);
		},
		loading: false
	});
};
/**
 * 查询课程评论列表
 * @param ctx
 * @param obj id        必填        课程ID
 * @param obj pagenum   选填        页大小，默认 15
 * @param obj pagestart  选填        起始页，默认 0
 * */
export const fetchCourseCommentList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_class_commentlist',
		body: {
			cid: obj.id,
			pagenum: obj.pagenum || 15,
			pagestart: obj.pagestart || 0
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: true
	});
};
/**
 * 发起课程评论
 * @param ctx
 * @param obj id        必填        课程ID
 * @param obj star      必填        分数
 * @param obj content   选填        评价内容
 * */
export const fetchCourseComment = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_class_comment',
		body: {
			cid: obj.id,
			star: obj.star,
			content: obj.content
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (code, desc, extra) => {
			ctx.dispatch('showTooltip', { msg: desc });
			obj.error && obj.error(code, desc);
		},
		loading: true
	});
};

/**
 * 获取课程路演内容
 *    @param ctx
 *    @param obj id 必填 路演id
 * */
export const fetchCourseRoadshowContent = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_class_noticepagecontent',
		body: {
			roadshowid: obj.id
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true,
		keepAllLine: true
	});
};
/**
 * 获取课程路演回放内容
 *    @param ctx
 *    @param obj id 必填 路演id
 * */
export const fetchCourseRoadshowRecordContent = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_class_recorddetail',
		body: {
			roadshowid: obj.id
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/**
 * 获取课程路演权限
 *    @param ctx
 *    @param obj id 必填 路演id
 * */
export const fetchCourseRoadshowAuth = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_class_noticepageauth',
		body: {
			roadshowid: obj.id,
			checkphone: obj.checkphone,
			checklogin: obj.checklogin
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			if (obj.error) {
				obj.error(code, desc, extra);
			} else {
				ctx.dispatch('showTooltip', { msg: desc });
			}
		},
		loading: false
	});
};

/**
 * 获取课程路演文档
 *    @param ctx
 *    @param obj id 必填 路演id
 * */
export const fetchCourseRoadshowDocment = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_class_noticepagedocument',
		body: {
			roadshowid: obj.id
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/**
 * 获取付费路演内容
 *    @param ctx
 *    @param obj id 必填 路演id
 * */
export const fetchChargeRoadshowContent = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_event_noticepagecontent',
		body: {
			roadshowid: obj.id
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: true,
		keepAllLine: true
	});
};
/**
 * 获取付费路演权限
 *    @param ctx
 *    @param obj id 必填 路演id
 * */
export const fetchChargeRoadshowAuth = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_paynoticepageauth',
		body: {
			eventid: obj.id,
			checkphone: obj.checkphone
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			ctx.dispatch('showTooltip', { msg: desc });
			obj.error && obj.error(code, desc);
		},
		loading: true
	});
};
/**
 * fetchOrderCharge 付费路演下单
 * @param ctx
 * @param obj amount 充值金额 （单位分）
 * @param obj id 路演id
 * **/
export const fetchOrderCharge = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_order_roadshow',
		body: {
			amount: obj.amount,
			roadshowid: obj.id
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 聊天
// Web端路演聊天记录列表接口。
// @obj: eid：必填。
export const fetchPageEventIm = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_page_eventim',
		body: {
			eventid: obj.eid
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

// 提问
// Web端发送提问接口。
export const fetchNewQuestion = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_question_new',
		body: {
			roadshowid: obj.eid,
			content: obj.content,
			verify: obj.verify
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: error => {
			console.log('提问请求出错');
			console.log(error);
		},
		loading: true
	});
};

// Web端获取我的提问列表接口。
export const fetchQuestionListByUid = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_question_listbyuid',
		body: {
			roadshowid: obj.eid,
			pagenum: obj.pageNum | 10,
			pagestart: obj.pageStart,
			verify: obj.verify
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: error => {
			console.log(error);
		},
		loading: false
	});
};

/**
 * 观看定点上报
 * @param ctx
 *    @param obj anchorpoint:   观看视频到毫秒，无小数位(没有时间，传-1)
 *    @param obj roadshowid:    路演ID
 * */
export const fetchRoadshowWatchRecord = (ctx, obj) => {
	comeinFetch({
		code_201: true,
		code_422: true,
		code_450: true,
		constant_key: 'json_roadshow_watchrecord',
		body: {
			anchorpoint: obj.anchorpoint || -1,
			roadshowid: obj.id
		},
		error: () => {}
	});
};

/**
 * 路演音视频播放打点统计
 * @param ctx
 *    @param obj eventtype:          统计事件类型:playbegin 、playing 、online
 *    @param obj roadshowid:    路演ID
 *    @param obj roadshowtype:  路演类型 : live、record
 * */
export const fetchStatisticRoadshow = (ctx, obj) => {
	comeinFetch({
		code_201: true,
		code_422: true,
		code_450: true,
		constant_key: 'json_statistic_roadshow',
		body: {
			eventtype: obj.type,
			roadshowid: obj.id,
			roadshowtype: obj.roadshowtype
		},
		error: () => {}
	});
};

/* 回放播放次数打点
 *	@audioid 回放文件id
 */
export const fetchRecordNote = (ctx, audioid) => {
	comeinFetch({
		code_201: true,
		code_422: true,
		code_450: true,
		constant_key: 'json_record_note',
		body: {
			audioid
		},
		error: () => {}
	});
};

// 招商合作
// 招商证券轮播直播列表
export const fetchChannelOpenZsNavEvents = (ctx, success) => {
	comeinFetch({
		constant_key: 'json_channelopen_zsnavevents',
		success: res => {
			success && success(res);
		},
		loading: true
	});
};

// 招商用户信息更新
export const fetchZszqUserInfoUpdate = (ctx, assetslevel) => {
	comeinFetch({
		constant_key: 'json_user_zszquserinfoupdate',
		body: {
			assetslevel
		}
	});
};

// 机构通相关
/**
 * 用户vip申请记录信息接口
 * json_vip_vipapplyinfo
 * viptype 必填   会员类型 0 一般会员 1 机构通 默认 1
 *
 * **/
export const fetchVipApplyInfo = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_vip_vipapplyinfo',
		body: {
			viptype: obj.viptype
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: obj.loading || false
	});
};

/**
 * 用户vip申请记录信息接口
 * json_vip_applyvip
 * viptype 必填   会员类型 0 一般会员 1 机构通 默认 1
 *
 * **/
export const fetchVipApplyVip = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_vip_applyvip',
		body: {
			viptype: obj.viptype
		},
		success: res => {
			obj.success && obj.success(res);
		},

		error: (code, desc) => {
			if (obj.error) {
				obj.error(code, desc);
			} else {
				ctx.dispatch('showTooltip', {
					msg: desc
				});
			}
		},
		loading: true
	});
};

/**
 * 分析师配置列表
 * json_vip_vipanalystrec
 * **/
export const fetchVipAnalystRec = (ctx, success) => {
	comeinFetch({
		constant_key: 'json_vip_vipanalystrec',
		success: res => {
			success && success(res);
		}
	});
};

/**
 * 通过UID取分析师ID
 * 用在路演点击用户信息栏跳转对应分析师主页
 */
export const fetchUserGetAnalyst = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_getanalyst',
		body: {
			tuid: obj.tuid
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

// 直播相关
/**
 * fetchEventJoinEvent 参与路演接口
 * @param: (String) eventid
 * **/
export const fetchEventJoinEvent = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_event_joinevent',
		body: {
			eventid: obj.id || obj.eid || obj.eventid,
			verify: obj.verify,
			receipt: obj.receipt,
			showfront: obj.showfront || '1'
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			if (obj.error) {
				obj.error(code, desc, extra);
			} else {
				ctx.dispatch('showTooltip', {
					msg: desc
				});
			}
		},
		loading: true
	});
};
//获取路演所有文档
export const fetchRoadshowAttachmentlist = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_attachmentlist',
		body: {
			roadshowid: obj.id || obj.eid || obj.eventid
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			if (obj.error) {
				obj.error(code, desc, extra);
			} else {
				ctx.dispatch('showTooltip', {
					msg: desc
				});
			}
		},
		loading: true
	});
};

// 分析师第三方映射信息接口
/**
 * @param ctx
 * @param uc      用户渠道
 * @param ms      第三方信息
 * @param success 成功回调
 * */

export const fetchAnalystChannelMapping = (ctx, { uc, ms, success }) => {
	comeinFetch({
		constant_key: 'json_analyst_channelmapping',
		body: {
			uc,
			mappingsource: ms
		},
		success: res => {
			success && success(res);
		}
	});
};

// vip
/**fetchVipMyVip 会员信息（请求成功后再次获取）**/
export const fetchVipMyVip = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_vip_myvip',
		success: res => {
			obj.success && obj.success(res);
		}
	});
};

/**fetchOrderReward 打赏**/
export const fetchOrderReward = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_order_reward',
		body: {
			amount: obj.amount,
			eventid: obj.eventid
		},
		success: res => {
			obj.success && obj.success(res);
		}
	});
};

/**
 * 课程下单接口
 *  参数名    必选    类型        说明
 * @amount    是    string    充值金额 （单位分）
 * @id        是    课程ID
 * **/
export const fetchOrderClass = (ctx, obj) => {
	/* 购买课程时，统计课程渠道来源
	 * 当购买课程ID和本地存储ID相同时，添加统计
	 * */
	const cc = JSON.parse(sessionStorage.getItem('courseChannel'));
	const channelId = cc && Number(obj.id) === Number(cc.courseId) ? cc.channelId : null;
	comeinFetch({
		constant_key: 'json_order_class',
		body: {
			amount: obj.amount,
			cid: obj.id,
			channelid: channelId || '-1'
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: obj.loading
	});
};

/** 投研秘书购买
 *  参数名     必选    类型        说明
 * @amount     是    string       金额
 * @roadshowid 是    string       路演id
 **/
export const fetchOrderResearch = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_order_research',
		body: {
			roadshowid: obj.roadshowid
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: obj.loading
	});
};

/**fetchOrderVip 会员购买续费下单接口**/
export const fetchOrderVip = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_order_vip',
		body: {
			productid: obj.productid
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: obj.loading
	});
};

/** fetchOrderCancel
 * 取消订单
 * @param ctx
 * @param obj ordernum 订单号
 * **/
export const fetchOrderCancel = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_order_cancel',
		body: {
			ordernum: obj.ordernum
		},
		success: () => {
			obj.success && obj.success();
		},
		loading: true
	});
};

/**fetchPayOrder 订单支付
 @ordernum: 是   订单号
 @paytype:  是   支付类型 1 微信， 2 支付宝， 3 银联， 4 钱包， 5 苹果， 6 牛币/J币 7 京东 8：怀新-微信支付 9：怀新-支付宝支付
 @password: 否   钱包支付密码： 当时钱包支付时必选
 @tradetype:否   支付交易类型 ： 默认0 APP支付；1 微信二维码支付 2： 微信网页支付 3: 支付宝网页支付
 @openid:    否   微信用户对于公众号的唯一ID， 当交易类型是 微信网页支付 时需要此参数
 @showurl:  否   商品链接 当交易类型是 支付宝网页支付 时需要此参数
 @returnurl:否   网页回调页面 当交易类型是 支付宝网页支付 时需要此参数**/
export const fetchPayOrder = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_pay_order',
		body: Object.assign(
			{
				ordernum: obj.ordernum,
				paytype: obj.paytype
			},
			obj.optional
		),
		success: res => {
			obj.success && obj.success(res);
		},
		error: errorObj => {
			obj.fail && obj.fail(errorObj);
		},
		loading: true
	});
};

/**fetchVipProducts 会员商品列表**/
export const fetchVipProducts = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_vip_products',
		success: res => {
			obj.success && obj.success(res);
		}
	});
};

/** 股票推荐股票历史数据 **/
export const fetchStockRecHistory = (ctx, { id, date, success }) => {
	comeinFetch({
		constant_key: 'json_stockrec_stockhistory',
		body: {
			stockrecid: id,
			begindate: date
		},
		success: res => {
			success && success(res);
		}
	});
};

/** 股票推荐观点 **/
export const fetchStockRecContents = (ctx, { id, success }) => {
	comeinFetch({
		constant_key: 'json_stockrec_contents',
		body: {
			stockrecid: id
		},
		success: res => {
			success && success(res);
		},
		loading: false
	});
};

/** 股票推荐基本信息接口 **/
export const fetchStockRecBaseInfo = (ctx, { id, success }) => {
	comeinFetch({
		constant_key: 'json_stockrec_baseinfo',
		body: {
			stockrecid: id
		},
		success: res => {
			success && success(res);
		},
		loading: false
	});
};

/** 股票推荐相关推荐 **/
export const fetchStockRecRelatedRecs = (ctx, { id, success }) => {
	comeinFetch({
		constant_key: 'json_stockrec_relatedrecs',
		body: {
			stockrecid: id
		},
		success: res => {
			success && success(res);
		},
		loading: false
	});
};

/** vip股票推荐 **/
export const fetchBannerVipStockRec = (ctx, success) => {
	comeinFetch({
		constant_key: 'json_banner_vipstockrec',
		success: res => {
			success && success(res);
		}
	});
};

// 关注操作接口
// @contentid: 关注内容id
// @contenttype: 关注内容类型：6.股票 7.专题
// @operate: 操作：1.添加关注，0.取消关注
export const fetchSubscriptionOperate = (content, obj) => {
	comeinFetch({
		constant_key: 'json_subscription_operate',
		body: {
			contentid: obj.id,
			contenttype: obj.type,
			operate: obj.operate
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

// 搜索接口
export const fetchSearch = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_search_searchall',
		body: {
			keyword: obj.keyword,
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '3',
			contenttypes: obj.types || '9999'
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

// 热搜词收集接口
export const fetchHotsearchCollect = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_hotsearch_collect',
		body: {
			searchContent: obj.searchContent || '',
			location: obj.location || 1
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: false
	});
};

// 获取调研活动列表接口
export const fetchSearchByTypeList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_search_searchbytype',
		body: {
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '16',
			keyword: obj.keyword,
			contenttype: obj.types,
			roadshowStatus: obj.roadshowStatus || '',
			roadshowInterval: obj.roadshowInterval || '',
			searchScope: obj.searchScope || '',
			bannerid: obj.bannerid || ''
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取调研活动列表接口
export const fetchSearchHotType = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_search_hotbytype',
		body: {
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '16',
			contenttype: obj.types
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 海报列表查询
export const fetchPosterList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_manager_share-poster-list',
		body: {
			begintime: obj.begintime,
			endtime: obj.endtime,
			longinIds: obj.longinIds,
			industryIds: obj.industryIds,
			userId: obj.userId,
			loading: true,
			ids: obj.ids
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error(code) {
			console.log('code', code);
			obj.error && obj.error(code);
		}
	});
};

// 获取单个栏目内容列表接口
export const fetchBannerList = (ctx, obj) => {
	if (!obj.optional) {
		obj.optional = {};
	}
	comeinFetch({
		constant_key: 'json_banner_list',
		body: Object.assign(
			{
				bannerid: obj.bannerid,
				pagestart: obj.pagestart || '0',
				pagenum: obj.pagenum || '15',
				topicType: obj.topicType || null
			},
			obj.optional
		),
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: obj.loading
	});
};

// 获取首页栏目列表接口
export const fetchBannerFirstPage = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_banner_firstpage',
		body: {
			channelid: obj.channelid,
			bannergroup: obj.bannergroup || '0'
		},
		success: res => {
			obj.success && obj.success(res);
		},
		keepAllLine: true
	});
};

// 获取首页搜索推荐滚动栏接口
export const fetchFirstList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_searchrecommend_firstlist',
		body: {},
		success: res => {
			obj.success && obj.success(res);
		}
	});
};

// 网页京东用户登录接口
export const fetchUserWebJdLogin = (ctx, { code, success }) => {
	comeinFetch({
		constant_key: 'json_user_webjdlogin',
		body: {
			code
		},
		success: res => {
			success && success(res);
		}
	});
};

// 获取微信用户信息
// @param { String } code
export const fetchWeiXinUserInfo = (ctx, { code, success }) => {
	comeinFetch({
		constant_key: 'json_page_weixinuserinfo',
		body: {
			code
		},
		success: res => {
			success && success(res);
		}
	});
};

// 微信登录
// @param { String } code
export const fetchWebWxLogin = (ctx, { code, success }) => {
	comeinFetch({
		constant_key: 'json_user_webwxlogin',
		body: {
			code
		},
		success: (res, extra) => {
			// 授权同时获取用户信息
			success && success(res, extra);
		}
	});
};

/** 用户当前登陆状态是否有效
 * 校验TOKEN
 * */
export const fetchUserToken = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_tokeninfo',
		body: {
			token: obj.token,
			uid: obj.uid
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

/** fetchBannerTopicArticle   **/
export const fetchBannerTopicArticle = (ctx, { topicid, pagestart = '0', pagenum = '15', success }) => {
	comeinFetch({
		constant_key: 'json_banner_topicarticle',
		body: {
			topicid,
			pagestart,
			pagenum
		},
		success: (res, extra) => {
			success && success(res, extra);
		},
		loading: false
	});
};

/** wx config **/
export const fetchWxConfig = ({ commit, state }, url) => {
	if (!isWx) {
		return;
	}
	comeinFetch({
		constant_key: 'json_page_weixin',
		body: {
			pageUrl: url
		},
		success: res => {
			wx.config({
				debug: false,
				appId: res.appId,
				timestamp: res.timestamp,
				nonceStr: res.nonceStr,
				signature: res.signature,
				jsApiList: [
					'onMenuShareTimeline',
					'onMenuShareAppMessage',
					'onMenuShareQQ',
					'onMenuShareQZone',
					'onMenuShareWeibo',
					'updateAppMessageShareData',
					'updateTimelineShareData',
					'getNetworkType',
					'chooseWXPay',
					'scanQRCode',
					'openLocation'
				],
				openTagList: ['wx-open-launch-weapp']
			});

			wx.error(err => {
				console.log('wx.config error', err);
			});
		}
	});
};

// 代理外部http请求
export const fetchProxyRequest = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_proxy_request',
		body: {
			url: obj.href,
			methodType: obj.methodType,
			param: obj.param,
			userId: obj.userId || null //userId为招商小程序白名单校验专用请求参数
		},
		success: res => {
			obj.success && obj.success(res);
		}
	});
};

// 获取回放搜索列表接口（回放推荐）
export const fetchRecordSearchList = (ctx, obj) => {
	if (!obj.optional) {
		obj.optional = {};
	}
	comeinFetch({
		constant_key: 'json_roadshow_recent-search',
		body: Object.assign(
			{
				bannerid: obj.bannerid,
				pagestart: obj.pagestart || '0',
				pagenum: obj.pagenum || '15',
				keyword: obj.keyword || ''
			},
			obj.optional
		),
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: obj.loading
	});
};

// 获取最新回放列表接口
export const fetchRecordNewestList = (ctx, obj) => {
	if (!obj.optional) {
		obj.optional = {};
	}
	comeinFetch({
		constant_key: 'json_roadshow_recent-new',
		body: Object.assign(
			{
				bannerid: obj.bannerid,
				pagestart: obj.pagestart || '0',
				pagenum: obj.pagenum || '15'
			},
			obj.optional
		),
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: obj.loading
	});
};

// 获取热门回放列表接口
export const fetchRecordHottestList = (ctx, obj) => {
	if (!obj.optional) {
		obj.optional = {};
	}
	comeinFetch({
		constant_key: 'json_roadshow_recent-hot',
		body: Object.assign(
			{
				bannerid: obj.bannerid,
				pagestart: obj.pagestart || '0',
				pagenum: obj.pagenum || '15'
			},
			obj.optional
		),
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: obj.loading
	});
};

// 获取IR行业列表接口
export const fetchFlagShipIndustries = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_industries',
		body: {},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取IR企业号行业数量接口
export const fetchFlagShipCount = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_count',
		body: {
			industryTagIds: Number(obj.id) || null
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

//获取分析师列表接口
export const fetchFilterBannerList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_analyst_bannerlist',
		body: {
			isSub: obj.isSub,
			industryTagIds: obj.industryTagIds,
			topicIdsArr: obj.topicIdsArr,
			page: obj.page || '0',
			size: obj.pagenum || '16'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取IR企业号列表接口
export const fetchFlagShipList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_list',
		body: {
			industryTagIds: Number(obj.id) || null,
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '15'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取IR企业号关注列表接口
export const fetchFlagShipSubList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_subscriptions',
		body: {
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '15'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取IR团队行业数量接口
export const fetchIRTeamCount = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irteam_count',
		body: {
			industryTagIds: Number(obj.id) || null
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取IR团队列表接口
export const fetchIRTeamList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irteam_list',
		body: {
			industryTagIds: Number(obj.id) || null,
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '16'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取IR团队关注列表接口
export const fetchIRTeamSubList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irteam_subscriptions',
		body: {
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '16'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取行业标签列表接口
export const fetchBusinessTags = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_business_tag400',
		body: {
			type: obj.type //1：路演会议全部 2：路演会议分析师 3： 路演会议上市公司 4:行业专家 5：调研活动 6：纪要 7：分析师列表 8：研究上市公司 9：研究分析师
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取调研活动列表接口
export const fetchResearchActivityList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_research_activity-list',
		body: {
			industryTagIds: Number(obj.id) || null,
			researchActivityStatus: Number(obj.status) || null,
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '16',
			title: obj.keyword
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取调研活动列表接口
export const fetchResearchSummaryList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_summary_list',
		body: {
			industryTagIds: Number(obj.id) || null,
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '16',
			keyword: obj.keyword
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取调研活动列表接口
export const fetchResearchSummarySearchList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_search_searchbytype',
		body: {
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '16',
			keyword: obj.keyword,
			contenttype: '22'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取调研活动列表接口
export const fetchIRStoreSearchList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_search_searchbytype',
		body: {
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '16',
			keyword: obj.keyword,
			contenttype: '20'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取个股列表接口
export const fetchStockSearchList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_search_searchbytype',
		body: {
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '16',
			keyword: obj.keyword,
			contenttype: '6'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取调研活动列表接口
export const fetchIRTeamSearchList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_search_searchbytype',
		body: {
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '16',
			keyword: obj.keyword,
			contenttype: '19'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取调研活动列表接口
export const fetchVIPInstitutionSearchList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_search_searchbytype',
		body: {
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '16',
			keyword: obj.keyword,
			contenttype: '25'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 获取调研活动列表接口
export const fetchMemberSearchList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_search_searchbytype',
		body: {
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '16',
			keyword: obj.keyword,
			contenttype: '26'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 是否需要进行安全验证
export const fetchUserWarnAuth = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_userwarn_auth',
		body: {},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

// 发送安全验证码
export const fetchUserWarnSendCode = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_userwarn_authcode',
		body: {},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

// 验证安全验证码
export const fetchUserWarnCheckCode = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_userwarn_checkcode',
		body: {
			authcode: obj.authcode
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

// 验证安全验证码
export const fetchInvestorSendCode = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_investor_authcode',
		body: {
			email: obj.email
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

// 通过对应的键值获取系统配置信息
export const fetchPropertyGetByKey = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_property_getbykey',
		body: {
			name: obj.name
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

// 获取自助会议列表详情
export const selfDetails = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_self_get-meet-details',
		body: {
			meetingId: obj.id
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};
// 获取自助会议列表详情(包含密码)
export const selfDetailspassword = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_self_get-meet-details-password',
		body: {
			meetingId: obj.id
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};
// 腾讯会议授权
export const userauthorizeCode = (ctx, obj) => {
	comeinFetch({
		url: '/usercenter/oidc/code',
		body: {
			uid: obj.uid
		},
		config: {
			headers: {
				token: obj.webtoken,
				'Content-Type': 'application/json;charset=utf-8'
			}
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

// 会员购买-职业列表
export const memberProfessionallist = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_tools_professionallist',
		body: {},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

// 会员购买-学历列表
export const memberEducationlist = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_tools_educationlist',
		body: {},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

// 会员购买-证件类型列表
export const memberCertificatelist = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_tools_certificatelist',
		body: {},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

// 会员购买-适应性题目
export const memberQuestionlist = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_suitability_questionlist',
		body: {},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

// 获取用户会员的购买判断
export const memberProgress = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_membership_progress',
		body: {},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

// 通知更新人脸核验
export const memberKycresult = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_suitability_kycresult',
		body: {},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		},
		loading: true
	});
};

// 会员购买前检测是否可以购买
export const memberOrderBuycheck = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_order_buycheck',
		body: {},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

// 提交用户基本信息(身份证、姓名等)
export const memberUinfoPut = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_suitability_uinfo-put',
		body: {
			name: obj.name,
			idNo: obj.idNo,
			sex: obj.sex,
			birthday: obj.birthday,
			country: obj.country,
			professional: obj.professional,
			employer: obj.employer,
			occupation: obj.occupation,
			education: obj.education,
			certificateType: obj.certificateType,
			certificateDate: obj.certificateDate,
			certificateDuration: obj.certificateDuration
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		},
		loading: true
	});
};

// 完善用户基本信息(住址、不良记录)
export const memberCompleteUinfo = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_suitability_complete-uinfo',
		body: {
			province: obj.province,
			city: obj.city,
			district: obj.district,
			detail: obj.detail,
			dishonest: obj.dishonest,
			dishonestRecord: obj.dishonestRecord
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		},
		loading: true
	});
};

// 下单会员
export const memberOrderMembership = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_order_membership',
		body: {
			goodchargeid: obj.goodchargeid
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		},
		loading: true
	});
};

// 查询订单状态
export const queryOrderStatus = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_order_query-order-status',
		body: {
			ordernum: obj.orderNum
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		},
		loading: true
	});
};

// 商品定价
export const memberMembershipGoodlist = (ctx, obj) => {
	comeinFetch({
		method: 'get',
		constant_key: 'json_membership_goods-detail',
		body: {},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

/** 提交适当性答题
 * @param ctx
 * @param obj answerStr: 回答明细 格式
						题目:选项1,选项2;题目:选项
						1:2;2:1,2;
 * */
export const memberSuitabilityAnswer = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_suitability_answer',
		body: {
			orderNum: obj.orderNum,
			answerStr: obj.answerStr || ''
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		},
		loading: true
	});
};

/** 确认风险协议
 * @param ctx
 * @param obj flowId: 提交适当性答题后返回的flowId
 * @param obj flowType: 1 确认适当性结果 2 确认风险承受能力评估结果 3 坚持购买 4 重新评测  5 确认合同 6 确认风险提示 7 放弃购买
 * */
export const memberConfirmflow = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_suitability_confirmflow',
		body: {
			flowId: obj.flowId,
			flowType: obj.flowType
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		},
		loading: true
	});
};

/** 申请退款
 * @param ctx
 * @param obj flowId: 提交适当性答题后返回的flowId
 * @param obj flowType: 1 确认适当性结果 2 确认风险承受能力评估结果 3 坚持购买 4 重新评测  5 确认合同 6 确认风险提示
 * */
export const memberApplyForRefund = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_refund_apply-for-refund',
		body: {
			orderNumber: obj.ordernum,
			reason: obj.reason
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		},
		loading: true
	});
};

export const memberInfo = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_membership_query-user-membership',
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		},
		loading: true
	});
};

export const memberCheckBenefit = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_membership_check-uid-benefit',
		body: {
			// AI小助手	ai_helper
			// 市场风向	market_trend
			// 投研内容	research_content
			// 会议工具	conf_tools
			// AI纪要	ai_summary
			// AI字幕助手	ai_captions_hepler
			// AI纪要助手	ai_minutes_assistant_hepler
			// AI公告助手	ai_notice_hepler
			// 市场情绪	market_sentiment
			// 市场热点	market_hot
			// 金牌路演	gold_roadshow
			// 脱水研报	real_research
			// 进门内参	comein_internal_ref
			// 自助路演	slef_help_roadshow
			// 自助会议	slef_help_meet
			// 云文档	cloud_documents
			benefitFuncCode: obj.benefitFuncCode
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		},
		loading: false
	});
};

/** 用户注销检测 * */
export const userCancellationCheck = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_cancellation_check',
		body: {},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

/** 发送注销验证码
 * @param ctx
 * @param obj code: 0 短信(默认短信)，1邮件
 * */
export const userCancellationAuthcode = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_cancellation_authcode',
		body: {
			codetype: obj.codetype || '0'
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

/** 注销验证码校验
 * @param ctx
 * @param obj code: 0 短信(默认短信)，1邮件
 * */
export const userCancellationAuthcodecheck = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_cancellation_authcodecheck',
		body: {
			authcode: obj.authcode || '0'
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		},
		loading: true
	});
};

/** 确认注销
 * @param ctx
 * @param obj authcode: 注销验证码
 * */
export const userCancellationConfirm = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_cancellation_confirm',
		body: {
			authcode: obj.authcode || '0'
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		},
		loading: true
	});
};

/** 进行身份认证检查
 * @param ctx
 * @param obj identity: （2分析师 3 机构投资者 4 公司高管）
 * @param res checkResult：检测结果 (0 可以认证 1 不可认证 2 认证中)
 * */
export const authCertificationCheck = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_auth_certification-check',
		body: {
			identity: obj.identity || 0
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 身份认证解除
 * @param ctx
 * @param obj identity: （2分析师 3 机构投资者 4 公司高管）
 * */
export const authCertificationRemove = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_auth_certification-remove',
		body: {
			identity: obj.identity || 0
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 获取定制音频水印
 * @param ctx
 * @success res：没有返回markedAudioUrl，则表示关闭了嵌入水印的功能
 * */
export const fetchSecurityWatermark = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_security_watermark',
		body: {
			roadshowid: obj.roadshowid || 0
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 获取路演分享
 * @param ctx
 * @success res：没有返回markedAudioUrl，则表示关闭了嵌入水印的功能
 * */
export const fetchRoadshowShareinfo = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_shareinfo',
		body: {
			roadshowId: obj.roadshowId || 0
		},
		success: res => {
			obj.success && obj.success(res);
		}
	});
};

// 会议详情获取（包含密码）
export const fetchGetMeetingDetailsPassword = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_self_get-meet-details-password',
		body: {
			meetingId: obj.meetingId || 0
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code, desc);
		}
	});
};

// 报名参会前鉴权操作
export const fetchSignUpToAttend = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_self_sign-up-to-attend',
		body: {
			meetingId: obj.meetingId || 0
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code, desc);
		},
		loading: true
	});
};

export const fetchAreaCodeList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_tools_areacodelistformat',
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code, desc);
		}
	});
};

// 名片识别
export const fetchBusinessCard = (ctx, obj) => {
	comeinFetch({
		constant_key: 'api_ocr_business-card',
		body: {
			viewUrl: obj.viewUrl
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code, desc);
		},
		loading: false
	});
};

// 图片上传
export const fetchOssSignature = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_oss_signature',
		body: {
			fileType: obj.fileType || 'img'
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code, desc);
		},
		loading: false
	});
};

// 游客模式信息提交
export const fetchVistorInfo = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_tourist-regist',
		body: obj.data,
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc) => {
			obj.error && obj.error(code, desc);
		},
		loading: false
	});
};

// 账号切换
export const fetchSwitchAccount = (ctx, obj) => {
	return new Promise((resolve, reject) => {
		comeinFetch({
			constant_key: 'json_identity_change-user-identity',
			body: {
				outsideOrgId: obj.id,
				uid: obj.uid || '',
				token: obj.token || ''
			},
			success: res => {
				obj.success && obj.success(res);
				resolve(res);
			},
			error: (code, desc) => {
				obj.error && obj.error(code, desc);
				reject(code, desc);
			},
			loading: false
		});
	});
};
